import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { BarchartProps } from '../Barchart';

export const BARCHART_DIALOG = 'BARCHART_DIALOG';

export const showBarchartDialog = (props: BarchartProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: BARCHART_DIALOG,
        props: ImmutableMap(props),
      }),
    ),
  );
};

export default showBarchartDialog;
